import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yrvj5ect2z: FaireBrandEntity = {
  token: "b_yrvj5ect2z",
  type: "brand",
  name: "OLIVIERI 1882  (Audax 1882 LLC)",
  avatarUrl:
    "https://cdn.faire.com/fastly/b74876caf211b34dde3541d355ff86d5595b5ff8cc0f37f396ff9b0a7d8ea868.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/49f9553ea62ba28ea203b010955d36a43ea8b410155ae48367cbd928d2cfaaae.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b74876caf211b34dde3541d355ff86d5595b5ff8cc0f37f396ff9b0a7d8ea868.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/49f9553ea62ba28ea203b010955d36a43ea8b410155ae48367cbd928d2cfaaae.jpeg",
  location: "NY, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 28,
  isInsider: true,
  description:
    "We are Olivieri 1882, a family-run bakery from Northern Italy, just outside Venice. Since 1882, we’ve been crafting exceptional baked goods in our historic laboratory, using time-honored recipes, slow natural leavening, and only the finest ingredients.\n\nOur specialties include Panettone, Pandoro, Colomba, and a variety of seasonal and year-round creations — all made with patience, care, and passion.\n\nOur unwavering commitment to excellence has earned us numerous international accolades. \n\nIn 2025, The New York Times named our Panettone “The Best Traditional Panettone”.\n\nYou won’t find our products in supermarkets. We work exclusively with premium boutiques, gourmet shops, and specialty retailers who share our dedication to quality, authenticity, and meticulous production standards.\n\nLet’s bring a piece of true Italian excellence to your customers. We’d love to partner with you.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:19.401Z",
    importedBy: "entity-db-cli",
  },
};
